import scroll from 'scroll';
import scrollDetection from 'scroll-doc';

// 'scroll-doc' is for cross-browser compatibility
const pageElement = scrollDetection();

const getConfigAndArgs = args => {
    if (typeof args[0] === 'number') {
        return [{}, ...args];
    }
    return [...args];
};

export const scrollTo = (...args) => {
    const [config, ...scrollArguments] = getConfigAndArgs(args);
    const { element, direction } = { element: pageElement, direction: 'top', ...config };
    scroll[direction](element, ...scrollArguments);
};
